module.exports = __webpack_public_path__ + "img/stars-03.96d677e6.svg";